import type { KeyboardEvent } from "react";
import type { AccountRowProps } from "./types.ts";

export function AccountRow({
  summary,
  checked,
  isEditing,
  editingValue,
  saving,
  reconnecting,
  onToggleFilter,
  onStartEdit,
  onCancelEdit,
  onCommitEdit,
  onEditingValueChange,
  onReconnect,
  onSetDefault,
}: AccountRowProps) {
  function handleEditKeyDown(event: KeyboardEvent<HTMLInputElement>) {
    if (event.key === "Enter") {
      event.preventDefault();
      onCommitEdit(summary.sessionId);
    } else if (event.key === "Escape") {
      event.preventDefault();
      onCancelEdit();
    }
  }

  return (
    <div className={`account-switcher-item-row ${checked ? "is-on" : ""}`}>
      <button
        type="button"
        className="account-switcher-item"
        onClick={() => !isEditing && onToggleFilter(summary.sessionId)}
        title={`${summary.provider} \u00b7 ${summary.status}`}
      >
        <span className="account-switcher-badge" style={{ background: summary.badgeColor }}>
          {summary.badge}
        </span>
        <span className="account-switcher-meta">
          {isEditing ? (
            <input
              type="text"
              className="account-switcher-edit-input"
              autoFocus
              value={editingValue}
              disabled={saving}
              onChange={(event) => onEditingValueChange(event.currentTarget.value)}
              onClick={(event) => event.stopPropagation()}
              onKeyDown={handleEditKeyDown}
              onBlur={() => onCommitEdit(summary.sessionId)}
              placeholder="Nome da conta"
              maxLength={128}
            />
          ) : (
            <span className="account-switcher-name">
              {summary.label}
              {summary.isDefault ? <em className="account-switcher-default-tag">{" \u00b7 padr\u00e3o"}</em> : null}
            </span>
          )}
          <span className="account-switcher-sub">
            {summary.subtitle || summary.provider} {"\u00b7"} {summary.status}
          </span>
        </span>
        <span className="account-switcher-check">{checked ? "\u2713" : ""}</span>
      </button>
      {!isEditing ? (
        <div className="account-switcher-row-actions">
          {summary.status === "qr" || summary.status === "disconnected" ? (
            <button
              type="button"
              className="account-switcher-reconnect-btn"
              title="Reconectar (escanear QR)"
              aria-label="Reconectar"
              disabled={reconnecting}
              onClick={(event) => {
                event.stopPropagation();
                onReconnect(summary.sessionId, summary.label);
              }}
            >
              {reconnecting ? "..." : "Reconectar"}
            </button>
          ) : null}
          <button
            type="button"
            className="account-switcher-icon-btn"
            title="Renomear conta"
            aria-label="Renomear"
            onClick={(event) => {
              event.stopPropagation();
              onStartEdit(summary.sessionId, summary.label);
            }}
          >
            {"\u270e"}
          </button>
          {!summary.isDefault ? (
            <button
              type="button"
              className="account-switcher-icon-btn"
              title="Definir como padr\u00e3o"
              aria-label="Definir como padr\u00e3o"
              onClick={(event) => {
                event.stopPropagation();
                onSetDefault(summary.sessionId);
              }}
            >
              {"\u2606"}
            </button>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
